module.exports = __webpack_public_path__ + "img/laprecision-placeholder.5ee41dd2.png";